import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/page-header";
import { OrgWizard } from "@/features/orgs";

export const Route = createFileRoute("/_authenticated/admin/orgs/new")({
  component: NewOrgPage,
});

function NewOrgPage() {
  return (
    <>
      <PageHeader
        eyebrow="The Motherhood"
        title="Set up an organization"
        description="Three steps: who they are, their brand, and who runs it."
      />
      <OrgWizard />
    </>
  );
}
